import { render, staticRenderFns } from "./QuoteBuilderLabourComponent.vue?vue&type=template&id=17d2c912"
import script from "./QuoteBuilderLabourComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderLabourComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17d2c912')) {
      api.createRecord('17d2c912', component.options)
    } else {
      api.reload('17d2c912', component.options)
    }
    module.hot.accept("./QuoteBuilderLabourComponent.vue?vue&type=template&id=17d2c912", function () {
      api.rerender('17d2c912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderLabour/QuoteBuilderLabourComponent.vue"
export default component.exports